import React, { useState } from "react";
import { Form, Input, Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import FormModal from "../../../components/FormModal";
import { extractMsg } from "../../../utils/errorUtils";

const { Dragger } = Upload;

export default function SkeyepredictAddProjectDialog({
  open,
  onClose,
  onSave,
}) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  const handleFinish = async (values) => {
    if (fileList.length === 0) {
      message.error("Please upload a .dat file");
      return;
    }
    setLoading(true);
    try {
      await onSave({ name: values.name, file: fileList[0] });
      form.resetFields();
      setFileList([]);
      onClose();
    } catch (error) {
      message.error(extractMsg(error, "Failed to add project"));
      console.error("Failed to add project:", error);
    } finally {
      setLoading(false);
    }
  };

  const uploadProps = {
    onRemove: () => setFileList([]),
    beforeUpload: (file) => {
      if (!file.name.endsWith(".dat")) {
        message.error("Only .dat files are allowed");
        return Upload.LIST_IGNORE;
      }
      if (file.size > 100 * 1024 * 1024) {
        message.error("File size exceeds the 100 MB limit");
        return Upload.LIST_IGNORE;
      }
      setFileList([file]);
      return false;
    },
    fileList,
    maxCount: 1,
  };

  return (
    <FormModal
      title="Add SkeyePredict Project"
      open={open}
      onClose={() => {
        form.resetFields();
        setFileList([]);
        onClose();
      }}
      onFinish={handleFinish}
      loading={loading}
      form={form}
      submitText="Create"
    >
      <Form.Item
        name="name"
        label="Project Name"
        rules={[{ required: true, message: "Project name is required" }]}
      >
        <Input placeholder="Enter project name" />
      </Form.Item>
      <Form.Item label="Data File (.dat)">
        <Dragger {...uploadProps}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag .dat file to this area to upload (max 100 MB).
          </p>
        </Dragger>
      </Form.Item>
    </FormModal>
  );
}
